export const difficulties = [
  'mythic',
  'heroic',
  'normal',
  'raid_finder',
] as const

export const difficultiesLabels = {
  mythic: 'Mythic',
  heroic: 'Heroic',
  normal: 'Normal',
  raid_finder: 'LFR',
} as const

export const difficultiesILVLDeficit = {
  Mythic: 0,
  Heroic: -13,
  Normal: -26,
  LFR: -39,
}

export const difficultiesTextColors = {
  mythic: 'text-quality-legendary ',
  heroic: 'text-quality-epic',
  normal: 'text-quality-rare',
  raid_finder: 'text-foreground',
}

type Difficulty = typeof difficulties[number]
export default Difficulty
